import {h} from 'preact';
import {withPickList} from '../index';

const EditAction = ( {pickList, className = 'link-2 font-normal text-base'} ) => {
    const {list, itemType, allowAddItem, actions} = pickList;
    const btnLabel = pickList.getToggleButtonLabel();

    if ( list.length === 0 && allowAddItem ) {
        return (
            <a data-testid="picklist-edit" className={className} title={`Add ${itemType}`}
               onClick={actions.toggleAddItem}>
                Add {itemType}
            </a>
        );
    }

    if ( pickList.isEditable() ) {
        return (
            <a data-testid="picklist-edit" className={className} title={btnLabel} onClick={actions.toggleEditing}>
                {btnLabel}
            </a>
        );
    }

    return null;
};

export default withPickList( EditAction );